import React from 'react';

const TranscriptionItem = ({ transcription }) => {
  const { isMine, userName, transcript, translation, timestamp, confidence } = transcription;

  return (
    <div className={`flex ${isMine ? 'justify-end' : 'justify-start'} animate-slide-up`}>
      <div
        className={`max-w-[85%] sm:max-w-[75%] md:max-w-[70%] rounded-xl px-2.5 sm:px-3 py-2 shadow-lg ${
          isMine
            ? 'bg-gradient-to-br from-orange-500 to-red-600 text-white rounded-tr-sm'
            : 'bg-gradient-to-br from-zinc-800 to-zinc-900 text-white rounded-tl-sm border border-white/10'
        }`}
      >
        <div className={`text-[10px] sm:text-xs font-semibold mb-0.5 sm:mb-1 ${
          isMine ? 'text-orange-200' : 'text-orange-400'
        }`}>
          {isMine ? 'You' : userName}
        </div>

        <div className="text-xs sm:text-sm leading-relaxed break-words">
          {transcript}
        </div>

        {translation && (
          <div className={`text-[10px] sm:text-xs italic mt-1 sm:mt-1.5 pt-1 sm:pt-1.5 border-t ${
            isMine ? 'border-white/20 text-orange-100' : 'border-white/10 text-zinc-300'
          }`}>
            💬 {translation}
          </div>
        )}

        <div className={`flex items-center justify-between gap-2 mt-1 sm:mt-1.5 text-[9px] sm:text-[10px] ${
          isMine ? 'text-white/70' : 'text-zinc-500'
        }`}>
          <span>{new Date(timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}</span>
          <div className="flex items-center gap-1">
            {confidence < 0.8 && (
              <span title={`Confidence: ${(confidence * 100).toFixed(0)}%`} className="text-yellow-400">
                ⚠️
              </span>
            )}
            {confidence >= 0.8 && (
              <span className="text-green-400 opacity-50">✓</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TranscriptionItem;
